let lastClickX, lastClickY;
document.addEventListener('click', (event) => {
  if (event.target.tagName.toLowerCase() === 'a') return;
  lastClickX = event.clientX;
  lastClickY = event.clientY;
});

// Write position to storage on old page
window.addEventListener('pageswap', (event) => {
  if (event.viewTransition && lastClick) {
    sessionStorage.setItem('lastClickX', lastClickX);
    sessionStorage.setItem('lastClickY', lastClickY);
  }
});

// Read position from storage on new page
window.addEventListener('pagereveal', (event) => {
  if (event.viewTransition) {
    lastClickX = sessionStorage.getItem('lastClickX');
    lastClickY = sessionStorage.getItem('lastClickY');
  }
});

// OLD PAGE LOGIC
window.addEventListener('pageswap', async (e) => {
    if (e.viewTransition) {
      const targetUrl = new URL(e.activation.entry.url);
  
      // Assuming isGalleryPage checks if the target URL is to the gallery page
      if (isGalleryPage(targetUrl)) {
        // We'll consider that you have a mechanism to extract a unique identifier for the products
        const productID = extractProductIdFromUrl(targetUrl);
  
        // Set view-transition-name values on the 'a' tag within product-card__figure
        // Clean up after the page got replaced
        setTemporaryViewTransitionNames([
          [document.querySelector(`.product-card__figure a[data-product-id="${productID}"]`), 'product-link'],
          [document.querySelector(`.product-card__figure img[data-product-id="${productID}"]`), 'product-image'],
        ], e.viewTransition.finished);
      }
    }
  });
  
  //#### New Page Logic (Navigating back to the product card)
  window.addEventListener('pagereveal', async (e) => {
    if (e.viewTransition) {
      const fromURL = new URL(navigation.activation.from.url);
      const currentURL = new URL(navigation.activation.entry.url);
  
      // Assuming isGalleryPage and isHomePage checks for correct pages
      if (isGalleryPage(fromURL) && isHomePage(currentURL)) {
        const productID = extractProductIdFromUrl(fromURL);
  
        // Set view-transition-name values on the elements in the gallery
        // Clean up after the snapshots have been taken
        setTemporaryViewTransitionNames([
          [document.querySelector(`.product-gallery__media img[data-product-id="${productID}"]`), 'product-image'],
          [document.querySelector(`.product-gallery__media a[data-product-id="${productID}"]`), 'product-link'],
        ], e.viewTransition.ready);
      }
    }
  });